export default "__VITE_ASSET__cupRVtXQ__"